import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import { Box } from '@mui/material';
import { forwardRef } from 'react';
import { useReviewContext } from '../../../Context';
import ApplyNowContainer from '../components/ApplyNowContainer';
import CardImage from '../components/CardImage';

export const MobileSidebarProduct = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  const {
    marketplaceEntity: { image },
  } = useReviewContext();

  const { resizable: resizableImage, small: smallImage } = image;
  const { optimized } = customImageWidthURLBuilder(
    resizableImage,
    {
      customImageWidth: smallImage.width,
      customImageQuality: 92,
      imageParentWidth: 100,
    },
    smallImage.url,
  );

  return (
    <Box
      display="flex"
      flexDirection="row"
      maxHeight="10rem"
      width="100%"
      py={2}
      px={3}
      gap={3.5}
      bgcolor="blues.lightest"
      ref={ref}
    >
      <Box width={optimized.parentElement.width}>
        <CardImage source={optimized.image.url} height={optimized.parentElement.height} />
      </Box>
      <Box flex={1}>
        <ApplyNowContainer />
      </Box>
    </Box>
  );
});
